import React from 'react'
import type { BankCardButton } from '../types'
import { PaymentMethodButtonStyled } from '../PaymentMethodButton.styled'
import { BankCardDisplay } from './BankCardDisplay'
import { makeAccessibleName } from './helpers'
import { Mastercard } from '../../Icons'

const issuerName = 'Mastercard'

export const MasterCardButton: BankCardButton = ({ lastFour, disabled, onClick }) => {
  return (
    <PaymentMethodButtonStyled
      provider='mastercard'
      aria-label={makeAccessibleName(issuerName, lastFour)}
      disabled={disabled}
      onClick={onClick}
    >
      <Mastercard />
      <BankCardDisplay issuerName={issuerName} lastFour={lastFour} />
    </PaymentMethodButtonStyled>
  )
}
